import { isApiIntegration } from './isApiIntegration.js';

const getEmbeddedApiConfigurationState = (integration) => {
  if (!isApiIntegration(integration)) {
    return null;
  }

  // Fresh metadata and detail project the marker at the top level. An explicit
  // null remains unconfirmed, even when cached settings contain an older value.
  const apiConfigured = Object.hasOwn(integration, 'apiConfigured') ? integration.apiConfigured : integration.settings?.apiConfigured;
  if (apiConfigured === true) {
    return 'configured';
  }
  if (apiConfigured === false) {
    return 'automatic';
  }
  return 'unconfirmed';
};

export default getEmbeddedApiConfigurationState;
